window.logError = (err, customAttributes) => {
  console.error(err)

  if (process.env.ENABLE_DT_LOGGING) {
    newrelic.noticeError(err, customAttributes)
  }
}
